<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>渠道信息设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>
    
        <el-input placeholder="请输入channelCode" clearable v-model.trim="channelCode">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div>
        <List></List>
        <!-- <ChannelCodeInfo></ChannelCodeInfo> -->
        <PageNation
          :total="totalCount"
          :size="size"
          :page="page"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import Creat from "./components/creat";
import List from "./components/list";
import PageNation from "../../../components/pagination";
import ChannelCodeInfo from './components/info'

export default {
  name: "Channel",
  data() {
    return {
      dialogVisible: false,
      channelCode: '',
      total: "",
      page: 1,
      size: 10,
      obj: {},
    };
  },
  components: {
    Creat,
    List,
    PageNation,ChannelCodeInfo
  },

  computed: {
    ...mapState("channel", ["totalCount"]),
  },

  methods: {
    ...mapActions("channel", ["getlist",'getUrlList']),
    closeDialog() {},
    handleSearch() {
       this.getUrlList({
        channelCode:this.channelCode,
        page: 1,
        size: this.size,
      });
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.obj = { ...this.obj, ...e };
      this.getUrlList({ ...this.obj,channelCode:this.channelCode });
    },
  },
 
};
</script>

<style lang="less" scoped></style>
